import React from 'react';
import cx from 'classnames';

import styles from './ToolsServicesSection.module.scss';
import toolsFirst from 'assets/images/about/tools.svg';
import toolsSecond from 'assets/images/about/tools2.svg';

export default function ToolsServicesSection() {
  return (
    <div className={styles.toolsServicesSection}>
      <ul className={styles.cardList}>
        <li className={styles.card}>
          <div className={styles.cardImg}>
            <img src={toolsFirst} alt="tools" />
          </div>
          <div className={styles.cardText}>
            <div className={styles.cardTitle}>Automated Up-to-Date Tools</div>
            We let you focus on recruiting top talent without dedicating all
            your time to repetitive tasks.
          </div>
        </li>
        <li className={cx(styles.card, styles.cardBlue)}>
          <div className={styles.cardText}>
            <div className={styles.cardTitle}>Customer Service</div>
            We are continually improving our products to cover user
            requirements.
          </div>
          <div className={styles.cardImg}>
            <img src={toolsSecond} alt="tools" />
          </div>
        </li>
      </ul>
    </div>
  );
}
